import {LOG_TYPES} from "../../../core/consts";
import {LogModel} from "./log-model";
import {BaseUtils} from "../base-utils";

export class LoggerUtils extends BaseUtils {
  _logger;
  logs: Array<LogModel>;
  registersToAddLog: Array<Function>;

  static injectables = [...BaseUtils.injectables];

  constructor() {
    super();

    this._logger = window['console'];
    this.logs = [];
    this.registersToAddLog = [];
  }

  log(title, context, ...args) {
    this.createLog(LOG_TYPES.info, title, context, [...args]);
  }

  warn(title, context, ...args) {
    this.createLog(LOG_TYPES.warning, title, context, [...args]);
  }

  error(title, context, ...args) {
    this.createLog(LOG_TYPES.error, title, context, [...args]);
  }

  time(title, context, ...args) {
    this.createLog(LOG_TYPES.time, title, context, [Date.now(), ...args]);
  }

  timeEnd(title, context, ...args) {
    this.updateTimeLog(LOG_TYPES.time,title, context, [Date.now(), ...args]);
  }

  createLog(type, title, context, args = []) {
    const logItem = new LogModel(type, title, context, [...args]);

    this.logs.push(logItem);
    this.registersToAddLog.forEach((callback) => callback(logItem));
  }

  updateTimeLog(type, title, context, args = []) {
    const logItem = new LogModel(type, title, context);
    const log: LogModel = this.logs.find((log) => {
      const equals = log.equals(logItem);
      const hasEndTime = log.args.length > 1;

      return equals && !hasEndTime;
    });

    log ? log.args.push(args[0]) : this.warn(title, context, 'Time not started')
  }

  printLog(logItem) {
    this._logger[logItem.type](logItem.title, ...logItem.args);
  }

  printLogs() {
    this.logs.map((log) => this.printLog(log));
  }

  clear() {
    this.logs.length = 0;
  }

  registerToAddLog(callback) {
    this.registersToAddLog.push(callback)
  }
}
